// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "wrestling" + "-" + "4d5a04a7" + ".css";
};